module.exports = __webpack_public_path__ + "img/vi.174b4f9e.svg";